import React, { useState } from 'react';
import { Row, Col, DatePicker, TimePicker, Form, Typography, Modal, Button, Select } from "antd"
import SectionTitle from "./SectionTitle"
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined'
import moment from "moment"

const { Text, Title } = Typography
const { Option } = Select

const timeSlots = ['6am - 8am', '8am - 10am', '10am - 12pm', '12pm - 2pm', '2pm - 4pm', '4pm - 6pm'];

const Date = ({ onDateChange, onTimeChange, refProp }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <Row gutter={24} className="home-calc__section fade-in" ref={refProp}>
      <SectionTitle title="Appointment date">
        <CalendarTodayOutlinedIcon/>
      </SectionTitle>
      <Col xs={{ span: 20, offset: 2 }} md={{ span: 24, offset: 0 }}>
        <Form.Item
          name="date"
          rules={[
            {
              required: true,
              message: 'Please select a date'
            },
          ]}
        >
          <DatePicker
            onChange={onDateChange}
            size="small"
            className="datepicker"
            disabledDate={(currentDate) => currentDate <= moment.now()}
          />
        </Form.Item>

        <Form.Item
          name="time"
          rules={[
            {
              required: true,
              message: 'Please select time'
            },
          ]}
        >
          <Select
            placeholder='Select time'
            className='timepicker'
            onSelect={onTimeChange}
            size='large'
          >
            {
              timeSlots.map(slot => <Option key={slot} value={slot}>{slot}</Option>)
            }
          </Select>
        </Form.Item>

        {/*<Title level={3}>How many cleaners will arrive?</Title>*/}
        {/*<Text>- Less than 3,000 sq ft, a solo or team of two cleaners will arrive, depending on availability.</Text>*/}
        {/*<br/>*/}
        {/*<Text>- More than 3,000 sq ft, a team of two cleaners or more will arrive.</Text>*/}

        <Title level={3}>Cancellation policy</Title>
        <Text>Free cancellation up to 24 hours before your appointment. Read our cancellation policy <Button type="link" onClick={showModal} style={{ padding: 0 }}>here</Button></Text>

        <Modal title="Cancellation policy" visible={isModalVisible} footer={null} onCancel={handleOk}>
          A $50 late cancellation fee is charged for appointments that are cancelled within 24 hours of the appointment start time.
        </Modal>
      </Col>
    </Row>
  )
}

export default Date